import { useRef, useEffect } from 'react'

import { useNavOverlay, NAV_OVERLAY_IDS } from 'Pods/UnifiedNavigation/Components/Navigation/Hooks/useNavOverlay'

// Open state for the redesigned avatar dropdown, backed by the shared nav-overlay
// coordinator so opening it closes any other open overlay (and vice versa). Keeps
// the legacy close-on-outside-click and close-on-Escape behaviour on top.
function useUserMenu() {
  const { isOpen, open, close } = useNavOverlay(NAV_OVERLAY_IDS.USER_MENU)
  const wrapperRef = useRef(null)
  const isOpenRef = useRef(isOpen)

  useEffect(() => {
    isOpenRef.current = isOpen
  }, [isOpen])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  function handleClickOutside(e) {
    const currentRef = wrapperRef.current

    if (isOpenRef.current && currentRef && !currentRef.contains(e.target)) {
      close(NAV_OVERLAY_IDS.USER_MENU)
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape' && isOpenRef.current) {
      close(NAV_OVERLAY_IDS.USER_MENU)
    }
  }

  function setIsOpen(value) {
    if (value) {
      open(NAV_OVERLAY_IDS.USER_MENU)
    } else {
      close(NAV_OVERLAY_IDS.USER_MENU)
    }
  }

  return { isOpen, setIsOpen, wrapperRef }
}

export { useUserMenu }
